import { Link } from "react-router-dom";
import NotificationPanel from "./NotificationPanel";
import NotificationManagementModal from "./NotificationManagementModal";
import { useEffect, useState } from "react";
import { useDebouncedCallback } from "../../constants/useDebouncedCallback";
import {
  getNotificationFilterList,
  getNotificationList,
  updateNotificationFilterAction
} from "../../redux/services/notification.service";
import { NotificationType } from "../../constants/NotificationType";

const Notification = () => {
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [actionReqNotificationData, setActionReqNotificationData] = useState([]);
  const [generalNotificationData, setGeneralNotificationData] = useState([]);
  const [actionReqNotificationUnreadCount, setActionReqNotificationUnreadCount] = useState(0);
  const [generalNotificationUnreadCount, setGeneralNotificationUnreadCount] = useState(0);
  const [actionReqNotificationCount, setActionReqNotificationCount] = useState(0);
  const [generalNotificationCount, setGeneralNotificationCount] = useState(0);
  const [notificationFilter, setNotificationFilter] = useState([]);

  const [notificationReqModel, setNotificationReqModel] = useState({
    WebuserId: 0,
    SearchText: "",
    NotificationTypeId: null,
    FilterBy: 1,
    StartRow: 1,
    PageSize: 5,
    RefreshTrigger: 0
  });

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        setLoading(true);

        const qry = `?searchText=${encodeURIComponent(notificationReqModel?.SearchText || "")}&notificationTypeId=${notificationReqModel?.NotificationTypeId ?? ""}&filterBy=${notificationReqModel?.FilterBy}&startRow=${notificationReqModel?.StartRow}&pageSize=${notificationReqModel?.PageSize}`;

        const response = await getNotificationList(qry);

        if (response.statusCode === 200) {
          const notifications = response.data.notifications;
          const counts = response.data.notificationCount;

          if (notificationReqModel?.NotificationTypeId === null) {
            setActionReqNotificationData(notifications.filter((x) => x.notificationTypeId === 1));

            setGeneralNotificationData(notifications.filter((x) => x.notificationTypeId === 2));
          } else if (notificationReqModel.NotificationTypeId === 1) {
            setActionReqNotificationData((prev) =>
              notificationReqModel.StartRow === 1 ? notifications : [...prev, ...notifications]
            );
          } else {
            setGeneralNotificationData((prev) =>
              notificationReqModel.StartRow === 1 ? notifications : [...prev, ...notifications]
            );
          }

          setActionReqNotificationCount(
            counts.find((x) => x.notificationTypeId === 1)?.totalCount ?? 0
          );

          setGeneralNotificationCount(
            counts.find((x) => x.notificationTypeId === 2)?.totalCount ?? 0
          );

          setActionReqNotificationUnreadCount(
            counts.find((x) => x.notificationTypeId === 1)?.unReadCount ?? 0
          );

          setGeneralNotificationUnreadCount(
            counts.find((x) => x.notificationTypeId === 2)?.unReadCount ?? 0
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadNotifications();
  }, [
    notificationReqModel.SearchText,
    notificationReqModel.NotificationTypeId,
    notificationReqModel.FilterBy,
    notificationReqModel.StartRow,
    notificationReqModel.PageSize
  ]);

  useEffect(() => {
    const notificationFilter = async () => {
      const response = await getNotificationFilterList();
      if (response.statusCode === 200) {
        setNotificationFilter(response.data);
      }
    };
    notificationFilter();
  }, []);

  const refreshNotifications = (notificationType) => {
    setNotificationReqModel((prev) => ({
      ...prev,
      NotificationTypeId: notificationType,
      StartRow: 1,
      PageSize: 5,
      SearchText: "",
      FilterBy: 1
    }));
  };
  const refreshOnDelete = (notificationType) => {
    setNotificationReqModel((prev) => ({
      ...prev,
      StartRow: 1,
      PageSize: 5,
      RefreshTrigger: prev.RefreshTrigger + 1
    }));
  };

  const loadMoreNotifications = (notificationType, startRow) => {
    setNotificationReqModel((prev) => ({
      ...prev,
      NotificationTypeId: notificationType,
      StartRow: startRow,
      PageSize: 5
    }));
  };

  const searchNotifications = useDebouncedCallback((notificationType, searchText) => {
    setNotificationReqModel((prev) => ({
      ...prev,
      NotificationTypeId: notificationType,
      SearchText: searchText,
      StartRow: 1,
      PageSize: 5
    }));
  }, 500);

  const filterNotifications = async (notificationType, filterBy, isActionFilter) => {
    if (isActionFilter) {
      const payload = {
        notificationFilterId: filterBy,
        notificationTypeId: notificationType
      };
      var response = await updateNotificationFilterAction(payload);
      if (response.statusCode === 200) {
        setNotificationReqModel((prev) => ({
          ...prev,
          NotificationTypeId: notificationType,
          SearchText: "",
          StartRow: 1,
          PageSize: 5,
          RefreshTrigger: prev.RefreshTrigger + 1
        }));
      }
    } else {
      setNotificationReqModel((prev) => ({
        ...prev,
        NotificationTypeId: notificationType,
        FilterBy: filterBy,
        StartRow: 1,
        PageSize: 5
      }));
    }
  };

  return (
    <>
      <NotificationManagementModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <div className="card">
        <div className="card-body py-8">
          <div className="row">
            <div className="col-md-10 align-center-y">
              <h4 className="m-0">Notifications</h4>
            </div>
            <div className="col-md-2  d-flex justify-content-end">
              <Link className="btn icon icon-left btn-primary" onClick={() => setIsModalOpen(true)}>
                Manage Notifications
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-12">
        <NotificationPanel
          notificationType={NotificationType.ActionRequired}
          notificationData={actionReqNotificationData}
          setNotificationData={setActionReqNotificationData}
          unRead={actionReqNotificationUnreadCount}
          setUnRead={setActionReqNotificationUnreadCount}
          totalCount={actionReqNotificationCount}
          filterList={notificationFilter}
          onViewMore={loadMoreNotifications}
          onRefresh={refreshNotifications}
          onDelete={refreshOnDelete}
          onSearch={searchNotifications}
          onFilter={filterNotifications}
        />
      </div>
      <div className="mt-12">
        <NotificationPanel
          notificationType={NotificationType.General}
          notificationData={generalNotificationData}
          setNotificationData={setGeneralNotificationData}
          unRead={generalNotificationUnreadCount}
          setUnRead={setGeneralNotificationUnreadCount}
          totalCount={generalNotificationCount}
          filterList={notificationFilter}
          onViewMore={loadMoreNotifications}
          onRefresh={refreshNotifications}
          onDelete={refreshOnDelete}
          onSearch={searchNotifications}
          onFilter={filterNotifications}
        />
      </div>
    </>
  );
};
export default Notification;
